import React, { Component } from 'react';
import ExportLeadsReport from '../../ContactLeadsReport/ExportLeadsReport';
import DateRangePicker from '../../../customlib/DateRangePicker';
import { Box, CircularProgress, Grid, LinearProgress, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import Global from '../../../customlib/Global';

class Filter extends Component {
    state = {  } 
    render() { 
        return (
            <Box>
                <Grid container spacing={1}>
                    {/* <Grid item xs={6}>
                        
                        <strong>{this.props.contactLeads.length} Salesman</strong>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                    {
                        Global.get().admin === true ? <ExportLeadsReport leadsReportData={this.props.contactLeads} /> : <></>
                    }
                    
                    </Grid> */}
                    <Grid item textAlign={"right"} xs={10} sx={{borderRadius: 10, padding: 1}}>
                        {/* <DateRangePicker onDateChanged={this.props.handleDateChanged} /> */}
                        <TextField
                            id="tanggal"
                            label="Tanggal"
                            value={this.props.startDate}
                            onChange={(event) => {
                            console.log(event.target.value);
                            let selectedDate = event.target.value;
                                this.props.handleDateChangedSingle(selectedDate);
                            }}
                            type="date"
                            fullWidth
                            size='small'
                        />
                    </Grid>
                    <Grid item xs={2} textAlign={"left"}>
                        <div onClick={() => {this.props.getContactLeads()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>
                    </Grid>
                    <Grid item xs={12} sx={{mb: "10px"}}>
                        {this.props.children}
                    </Grid>
                </Grid>
                {
                    this.props.isLoading === true && <LinearProgress />
                }
            </Box>
            
        );
    }
}
 
export default Filter;